<form [formGroup]="formGroup!">
  <div class="row mb-2">
    <div
      *ngFor="let input of inputs; let i = index"
      class="mb-2 d-none d-lg-block d-xl-block"
      [ngClass]="input.columnClass"
    >
      <app-input-container
        [label]="input.label ? getTranslationKey(input.label) : ''"
        [for]="input.name"
        [isRequired]="input.isRequired!"
        [biggerFont]="true"
      >
        <app-radio-button
          [strictValueKey]="input.strictValueKey"
          [name]="input.name"
          [controlName]="input.name"
          (valueChange)="onChange($event, input)"
        ></app-radio-button>
      </app-input-container>
    </div>

    <div class="d-block d-lg-none d-xl-none mb-2" >
      <div class="mb-3">
        <!-- <app-switch-button
          [strictValueKey]="switchButtonStrictValueKeys!"
          [value]="radioGroup.radioButtonKey"
          (valueChange)="switchButtonValueChange($event)"
        ></app-switch-button> -->
      </div>

      <app-input-container
        *ngIf="radioGroup"
        [label]="radioGroup.label ? getTranslationKey(radioGroup.label) : ''"
        [for]="radioGroup.name"
        [isRequired]="radioGroup.isRequired!"
      >
        <app-radio-button
          [strictValueKey]="radioGroup.strictValueKey"
          [name]="radioGroup.name"
          [controlName]="radioGroup.name"
          (valueChange)="onChange($event, radioGroup)"
        ></app-radio-button>
      </app-input-container>
    </div>
    <app-validation
      [hidden]="
        !getValidationMessagesOfForm(formGroup!) ||
        getValidationMessagesOfForm(formGroup!)?.length === 0
      "
      [validationMessages]="getValidationMessagesOfForm(formGroup!)!"
    ></app-validation>
  </div>
</form>
